import { isEmptyObject } from './utils';

const isModalErrorMessage = (error) => {
  return (
    !isEmptyObject(error) &&
    (error.hasOwnProperty('message') || error.hasOwnProperty('detail'))
  );
};
export default isModalErrorMessage;
